<template>
  <div>
    <h1>暂时未接入</h1>
  </div>
</template>

<script>
export default {};
</script>

<style lang='scss' scoped>
h1 {
  margin: auto;
  text-align: center;
}
</style>
